import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import logo from "./assets/Nexus_logo@3x.png";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import Loader from "./loader";
import { TEXT } from "./dictionary";

const ConfirmEmail = ({language , setLanguage}) => {
  const [isLoading, setIsLoading] = useState(false);
// console.log("asdkhksajdf",language)
  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
    localStorage.setItem("unauthorized_pages_language", e.target.value);
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
     .email(TEXT[language].invalidEmail)
     .required(TEXT[language].emailRequired),
      // .email("Invalid email address")
      // .required("Email is required"),
    // password: Yup.string()
    //   .required("Password is required")
    //   .min(8, "Password must be at least 8 characters")
    //   .matches(/[A-Z]/, "Password must contain at least one uppercase character"),
    // confirmPassword: Yup.string()
    //   .oneOf([Yup.ref("password"), null], "Passwords must match")
    //   .required("Confirm Password is required")
    //   .min(8, "Password must be at least 8 characters")
    //   .matches(/[A-Z]/, "Password must contain at least one uppercase character"),
  });


  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    // console.log(values)
    try {
      const res = await fetch(ApiUrl + "/api/user/send-reset-password-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: values.email,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        // toast.success(data.message);
        toast.success(TEXT[language].success);
      } else {
        toast.error(TEXT[language].error);
        // toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  return (
    <div
      className="ResetPassword form-wrapper"
      style={{ position: "relative" }}
    >
      {isLoading ? (
        <div className={`splash-screen`}>
          <Loader />
        </div>
      ) : (
        <main className="form-signin mx-auto">
          <div
            className=""
            style={{ position: "absolute", right: "30px", top: "20px" }}
          >
            <select
              value={language}
              onChange={handleLanguageChange}
              style={{
                // width: "150px",
                height: "38px",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "6px",
                border: "1px solid #ced4da",
                backgroundColor: "#ffffff",
                color: "#495057",
                padding: "0px 6px",
                boxShadow: "0px 1px 2px rgba(0,0,0,0.08)",
                cursor: "pointer",
                width: "130px",
                height: "30px",
              }}
            >
              <option value="en">{TEXT[language].langEnglish}</option>
              <option value="fr">{TEXT[language].langFrench}</option>
            </select>
          </div>
          <Formik
            initialValues={{
              email: "",
              // password: "",
              // confirmPassword: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              <div className="d-flex justify-content-center">
                <Link to="/">
                  <img className="mb-4 logo" width="100px" src={logo} alt="" />
                </Link>
              </div>
              <div className="form-floating mt-3">
                <Field type="email" name="email" className="form-control" />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error text-danger"
                />
                <label htmlFor="floatingInput ">
                  {TEXT[language].emailLabel}
                </label>
              </div>
              <button
                className="w-100 admin-btn btn-lg btn-primary mt-3"
                type="submit"
              >
                {/* Confirm Email */}
                {TEXT[language].confirmEmailBtn}
              </button>
            </Form>
          </Formik>
        </main>
      )}
    </div>
  );
};

export default ConfirmEmail;
